/* eslint-disable @typescript-eslint/ban-ts-comment */
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Checkbox,
  DialogContent,
  FormControlLabel,
  FormLabel,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import FocusTrap from "@mui/material/Unstable_TrapFocus";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { sendToolRequest } from "../../services/tool.service";
import Terms from "../../constants/terms.json";
import { FormInputType, Formfield, tools } from "../../tools/tools";
import useScreen from "../common/UseScreen";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../store/system.store";
import "./toolFormModal.scss";

interface ToolFormModalProps {
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  tool: any;
}

const ToolFormModal: FC<ToolFormModalProps> = ({ show, setShow, tool }) => {
  const { isMobile } = useScreen();
  const [inputFields, setInputFields] = useState<Formfield[]>();
  const [inputMap, setInputMap] = useState<any>({})
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showTerms, setShowTerms] = useState<boolean>(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    tools.forEach((toolObj) => {
      if (tool?.id === toolObj.id) {
        setInputFields(
          toolObj.fieldSections?.flatMap((section) => {
            return section.fields.map((field) => {
              if (!field.options) {
                return { ...field, input: undefined };
              } else {
                return { ...field, input: field.options[0] };
              }
            });
          })
        );
      }
    });
  }, [tool]);

  useEffect(() => {
    inputFields?.forEach(field => {
      setInputMap((prevInputMap: any) => ({
        ...prevInputMap,
        [field.backendHeader]: field,
      }));
    });
  }, [inputFields]);
  const handleFormChange = (fieldName: string, event: any) => {
    setInputFields(
      inputFields?.map((field) => {
        if (inputMap[field.backendHeader].backendHeader === fieldName) {
          if (field.type == FormInputType.FILE) {
            return { ...field, input: event.target.files[0] };
          } else {
            return { ...field, input: event.target.value };
          }
        } else {
          return { ...field };
        }
      })
    );
    // setShowDialog(true);
  };

  const handleSubmit = async (e: any) => {
    try {
      e.preventDefault();
      if (!tool?.isFormData && tool) {
        const newObj = inputFields?.map((field) => {
          const obj: any = {}; //@ts-ignore
          // obj[field.header] = field.input;

          if (field.type == FormInputType.NUMBER) {
            //@ts-ignore
            obj[field.backendHeader] = Number(field.input);
          } else if (field.type == FormInputType.DATE) {
            //@ts-ignore
            obj[field.backendHeader] = Date.parse(field.input);
          } else {
            //@ts-ignore
            obj[field.backendHeader] = field.input;
          }
          return obj;
        });
        //@ts-ignore
        const result = newObj.reduce((acc, curr) => Object.assign(acc, curr), {});

        const data: any = await sendToolRequest(result, tool.id, tool.hrefBackend, false);
        //@ts-ignore
        if (data?.statusText == "Created") {
          dispatch(showSnackbar({ msg: "Request submitted successfully.", isError: false }));
          window.history.back()
          setTimeout(() => {
            if (tool.id === "track-master") {
              navigate(`/order/track-master/${data?.details.id}`);
            } else navigate("/");
          }, 3000);
        } else {
          dispatch(showSnackbar({ msg: "Something went wrong.", isError: true }));
          window.history.back()
        }
      } else {
        const formData: any = {};
        inputFields?.forEach((field) => {
          // if (field.type !== FormInputType.FILE) {
          const obj: any = {};
          if (field.type === FormInputType.NUMBER) {
            //@ts-ignore
            obj[field.backendHeader] = Number(field.input);
          } else if (field.type === FormInputType.DATE) {
            //@ts-ignore
            obj[field.backendHeader] = Date.parse(field.input);
          } else {
            //@ts-ignore
            obj[field.backendHeader] = field.input;
          }
          formData[field.backendHeader] = obj[field.backendHeader]

        });

        if (tool) {
          const data = await sendToolRequest(formData, tool.id, tool.hrefBackend, true);
          if (data?.statusText == "Created") {
            dispatch(showSnackbar({ msg: "Request submitted successfully.", isError: false }));
            setShow(false);
            window.history.back()
            setTimeout(() => {
              navigate("/");
            }, 4000);
          } else {
            dispatch(showSnackbar({ msg: "Something went wrong.", isError: true }));
            window.history.back()
          }
        }
      }
    } catch (error) {
      console.log(error);
      dispatch(showSnackbar({ msg: "Something went wrong.", isError: true }));
    }
  };
  return (
    <FocusTrap open={show}>
      <DialogContent>
        <Box className="tool-form-wrapper" sx={{ display: show ? "flex" : "none" }}>
          <Box className={`overlay ${showTerms && "terms"}`}>
            <Box
              className={`popup ${showTerms && "terms"}`}
              sx={isMobile ? { maxHeight: "100vh", overflow: "auto" } : { overflow: "hidden" }}
            >
              <Box className="section-header-modal">
                <Box className="section-details">
                  <Box className="section-title-form">
                    <Typography variant="h1" sx={{ alignSelf: "baseline" }}>
                      {" "}
                      {tool?.header} Purchase Form
                    </Typography>
                  </Box>
                  <Box className="section-actions">
                    <IconButton
                      onClick={() => {
                        setShow(false);
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
              <Box className="popup-body">
                <form
                  onSubmit={(ev) => {
                    ev.preventDefault();
                    setShowTerms(true);
                  }}
                >
                  {inputFields?.map((field, index) => {
                    if (field.type === FormInputType.TEXT) {
                      return (
                        <Box key={index} className="form-control">
                          <FormLabel
                            sx={{
                              width: "100%",
                              fontSize: "0.875rem !important",
                              fontWeight: 600,
                              display: "block",
                              color: "var(--black)",
                            }}
                          >
                            {field.header}
                          </FormLabel>
                          <input
                            required
                            type="text"
                            onInput={(ev) => {
                              handleFormChange(field.backendHeader, ev);
                            }}
                            placeholder={field.header}
                            //@ts-ignore
                            value={field.input}
                            name={field.backendHeader}
                            style={{
                              width: "100% !important",
                              background: "none !important",
                              height: "44px",
                              margin: "0px",
                              display: "block",
                              padding: "12px 14px",
                              borderRadius: "7px",
                              border: "1px solid var(--gray)",
                              outline: 0,
                            }}
                          />
                        </Box>
                      );
                    }
                    if (field.type === FormInputType.NUMBER) {
                      return (
                        <Box key={index} className="form-control">
                          <FormLabel
                            sx={{
                              width: "100%",
                              fontSize: "0.875rem !important",
                              fontWeight: 600,
                              display: "block",
                              color: "var(--black)",
                            }}
                          >
                            {field.header}
                          </FormLabel>
                          <input
                            name={field.backendHeader}
                            required
                            type="number"
                            onInput={(ev) => {
                              handleFormChange(field.backendHeader, ev);
                            }}
                            placeholder={field.header}
                            //@ts-ignore
                            value={field.input}
                            style={{
                              width: "100% !important",
                              background: "none !important",
                              height: "44px",
                              margin: "0px",
                              display: "block",
                              padding: "12px 14px",
                              borderRadius: "7px",
                              border: "1px solid var(--gray)",
                              outline: 0,
                            }}
                          />
                        </Box>
                      );
                    } else if (field.type === FormInputType.SELECT) {
                      return (
                        <Box key={index} className="form-control">
                          <FormLabel
                            sx={{
                              width: "100%",
                              fontSize: "0.875rem !important",
                              fontWeight: 600,
                              display: "block",
                              color: "var(--black)",
                            }}
                          >
                            {field.header}
                          </FormLabel>
                          <select
                            required
                            name={field.backendHeader}
                            onChange={(ev) => {
                              handleFormChange(field.backendHeader, ev);
                            }}
                            // @ts-ignore
                            value={field.input}
                            style={{
                              width: "100%",
                              background: "none !important",
                              height: "44px",
                              margin: "0px",
                              display: "block",
                              padding: "12px 14px",
                              borderRadius: "7px",
                              border: "1px solid var(--gray)",
                              outline: 0,
                            }}
                          >
                            <option defaultValue={1} disabled value={"1"}>
                              Choose:
                            </option>

                            {field.options?.map((option, index) => {
                              return (
                                <option key={index} value={option}>{`${option.charAt(0).toUpperCase() + option.slice(1).toLowerCase()
                                  }`}</option>
                              );
                            })}
                          </select>
                          {field.notes ? <p>{field.notes}</p> : null}
                        </Box>
                      );
                    } else if (field.type === FormInputType.BIGTEXT) {
                      return (
                        <Box key={index} className="form-control">
                          <FormLabel
                            sx={{
                              width: "100%",
                              fontSize: "0.875rem !important",
                              fontWeight: 600,
                              display: "block",
                              color: "var(--black)",
                            }}
                          >
                            {field.header}
                          </FormLabel>
                          <textarea
                            name={field.backendHeader}
                            rows={5}
                            maxLength={500}
                            required
                            onInput={(ev) => {
                              handleFormChange(field.backendHeader, ev);
                            }}
                            // @ts-ignore
                            value={field.input}
                            style={{
                              width: "100%",
                              background: "none !important",

                              margin: "0px",
                              display: "block",
                              padding: "12px 14px",
                              borderRadius: "7px",
                              border: "1px solid var(--gray)",
                              outline: 0,
                            }}
                          />
                        </Box>
                      );
                    } else if (field.type === FormInputType.DATE) {
                      return (
                        <Box key={index} className="form-control">
                          <FormLabel
                            sx={{
                              width: "100%",
                              fontSize: "0.875rem !important",
                              fontWeight: 600,
                              display: "block",
                              color: "var(--black)",
                            }}
                          >
                            {field.header}
                          </FormLabel>
                          <input
                            name={field.backendHeader}
                            type="datetime-local"
                            onChange={(ev) => {
                              handleFormChange(field.backendHeader, ev);
                            }}
                            style={{
                              width: "100% !important",
                              background: "none !important",
                              height: "44px",
                              margin: "0px",
                              display: "block",
                              padding: "12px 14px",
                              borderRadius: "7px",
                              border: "1px solid var(--gray)",
                              outline: 0,
                            }}
                          />
                        </Box>
                      );
                    } else if (field.type === FormInputType.FILE) {
                      return (
                        <Box key={index} className="form-control">
                          <FormLabel
                            sx={{
                              width: "100%",
                              fontSize: "0.875rem !important",
                              fontWeight: 600,
                              display: "block",
                              color: "var(--black)",
                            }}
                          >
                            {field.header}
                          </FormLabel>
                          <input
                            name={field.backendHeader}
                            type="file"
                            onChange={(ev) => handleFormChange(field.backendHeader, ev)}
                            style={{
                              width: "100% !important",
                              background: "none !important",
                              height: "44px",
                              margin: "0px",
                              display: "block",
                              padding: "12px 14px",
                              borderRadius: "7px",
                              border: "1px solid var(--gray)",
                              outline: 0,
                            }}
                          />
                        </Box>
                      );
                    }
                  })}
                  <Box className="form-control">
                    <Button
                      type="submit"
                      sx={{ width: "100%", height: "44px" }}
                      variant="contained"
                    >
                      Submit
                    </Button>
                  </Box>
                </form>
              </Box>
            </Box>
          </Box>
        </Box>
        <Modal
          open={showTerms}
          onKeyDown={(e) => {
            if (e.code === "Escape") setShowTerms(false);
          }}
        >
          <Box className={`overlay ${showTerms && "terms"}`}>
            <Box className={`popup ${showTerms && "terms"}`}>
              <Box className="section-header-modal">
                <Box className="section-details">
                  <Box className="section-title-form">
                    <Typography variant="h1" sx={{ alignSelf: "baseline" }}>
                      {" "}
                      {tool?.header} Purchase Form - Terms and Conditions
                    </Typography>
                  </Box>
                  <Box className="section-actions">
                    <IconButton
                      onClick={() => {
                        setShow(false);
                        setShowTerms(false);
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
              <Box className="term" id="terms">
                {Terms.map((element, key) => {
                  return (
                    <Box key={key}>
                      <Typography className="term-header" variant="h3">
                        {element.title}
                      </Typography>
                      {element.subtitle ? (
                        <Typography className="term-sub-header" variant="h4">
                          {element.subtitle}
                        </Typography>
                      ) : null}
                      <Typography className="term-paragraph">{element.paragraph}</Typography>
                    </Box>
                  );
                })}
                <FormControlLabel
                  control={
                    <Checkbox
                      value={checked}
                      onChange={() => {
                        if (checked) {
                          setChecked(false);
                        } else {
                          setChecked(true);
                        }
                      }}
                    />
                  }
                  label="I agree to these terms and conditions."
                />
              </Box>
              <Box className={`term-actions`}>
                <Typography variant="h5">
                  Have you read the terms and condition and are willing to proceed?
                </Typography>
                <Box>
                  <Button
                    color="error"
                    onClick={() => {
                      setShowTerms(false);
                    }}
                  >
                    Go back
                  </Button>
                  <Button disabled={!checked} onClick={handleSubmit}>
                    Submit request
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Modal>
      </DialogContent>
    </FocusTrap>
  );
};

export default ToolFormModal;
